export const campaignReportsRequestTypes = {
  Applications: 'Apps',
  Date: 'Date',
  Country: 'Country',
  Creative: 'Creative',
};

export const campaignReportsUniqueFields = {
  Apps: 'pba_number',
  Date: 'dateUnix',
  Country: 'CountryCode',
  Creative: 'bn_bannerId',
};

export const cellWidth = {
  bid: '172px',
  AvgCpi: '78px',
  Impressions: '120px',
  event: '120px',
  base: '100px',
};

export const getInitialSelectedApps = {
  Apps: true,
};

export const campReportsSearchUISettings = {
  Apps: {
    searchBox: true,
    filterBtn: true,
    bulkActionBtn: true,
    exportBtn: true,
    columnsBtn: true,
  },
  Date: {
    searchBox: false,
    filterBtn: false,
    bulkActionBtn: false,
    exportBtn: true,
    columnsBtn: true,
  },
  Country: {
    searchBox: true,
    filterBtn: false,
    bulkActionBtn: false,
    exportBtn: true,
    columnsBtn: true,
  },
  Creative: {
    searchBox: false,
    filterBtn: false,
    bulkActionBtn: true,
    exportBtn: true,
    columnsBtn: true,
  },
};

export const campaignReportsDefaultSelectedCols = {
  title1: 'Available columns',
  title2: 'Selected columns',
  cols: [
    {
      colName: 'Impressions',
      label: 'Viewable Impressions',
      isSelected: true,
      selectedOrder: 1,
    },
    {
      colName: 'Clicks',
      label: 'Clicks',
      isSelected: true,
      selectedOrder: 2,
    },
    {
      colName: 'Installs',
      label: 'Installs',
      isSelected: true,
      selectedOrder: 3,
    },
    {
      colName: 'Cost',
      label: 'Cost',
      isSelected: true,
      selectedOrder: 4,
    },
    {
      colName: 'video_views',
      label: 'Video Views',
      isSelected: false,
      selectedOrder: 0,
    },
    {
      colName: 'video_completed',
      label: 'Video Ended',
      isSelected: false,
      selectedOrder: 0,
    },
    {
      colName: 'eCPM',
      label: 'eCPM',
      isSelected: true,
      selectedOrder: 5,
    },
    {
      colName: 'CR',
      label: 'Conv. rate',
      isSelected: true,
      selectedOrder: 6,
    },
    {
      colName: 'CTR',
      label: 'CTR',
      isSelected: true,
      selectedOrder: 7,
    },
  ],
};
